import {
  FETCH_EXCHANGE_LIST,
  FETCH_EXCHANGE_LIST_SUCCESS,
  FETCH_EXCHANGE_LOADER,
  SHOW_DASHBOARD_MESSAGE,
  HIDE_DASHBOARD_MESSAGE,
  FETCH_QUOTE,
  SHOW_QUOTE_LOADER,
  FETCH_QUOTE_SUCCESS,
  FETCH_PATIENTS_LIST_TODAY,
  SHOW_PATIENTS_LIST_TODAY_LOADER,
  FETCH_PATIENTS_LIST_TODAY_SUCCESS,
} from 'constants/ActionTypes';

export const fetchExchangeList = (date, currency) => {
  return {
    type: FETCH_EXCHANGE_LIST,
    payload: { date, currency }
  };
};
export const fetchExchangeListSuccess = (data) => {
  return {
    type: FETCH_EXCHANGE_LIST_SUCCESS,
    payload: data
  };
};
export const showExchangeLoader = () => {
  return {
    type: FETCH_EXCHANGE_LOADER,
  };
};
export const showDashboardMessage = (message, messageStatus = false) => {
  return {
    type: SHOW_DASHBOARD_MESSAGE,
    payload: { message, messageStatus }
  };
};
export const hideDashboardMessage = () => {
  return {
    type: HIDE_DASHBOARD_MESSAGE
  };
};
export const fetchQuote = (date) => {
  return {
    type: FETCH_QUOTE,
    payload: { date }
  };
};
export const showQuoteLoader = () => {
  return {
    type: SHOW_QUOTE_LOADER
  };
};
export const fetchQuoteSuccess = (data) => {
  return {
    type: FETCH_QUOTE_SUCCESS,
    payload: data
  };
};
export const fetchPatientsList = (data) => {
  return {
    type: FETCH_PATIENTS_LIST_TODAY,
    payload: data 
  };
};
export const showPatientsListLoader = () => {
  return {
    type: SHOW_PATIENTS_LIST_TODAY_LOADER
  };
};
export const fetchPatientsListSuccess = (data) => {
  return {
    type: FETCH_PATIENTS_LIST_TODAY_SUCCESS,
    payload: data
  };
};



// WEBPACK FOOTER //
// ./actions/Dashboard.js